/**
 * Root reducer
 * @module reducers/root
 */

import s3Upload from './s3Upload';

/**
 * Root reducer
 * @function
 * @param {Object} state Current state
 * @param {Object} action Action to be handled
 * @returns {Object} New state
 */
const reducers = {
  s3Upload,
};

export default reducers;
